// extracted by mini-css-extract-plugin
export var dataChart = "dynamic-zone-component-module--dataChart--pC2ui";
export var dataTable = "dynamic-zone-component-module--dataTable--LREls";
export var dataTableFooter = "dynamic-zone-component-module--dataTableFooter--uEIOh";
export var dataTableHeader = "dynamic-zone-component-module--dataTableHeader--jcy16";
export var dataTableRow = "dynamic-zone-component-module--dataTableRow--vZyNH";
export var listTitle = "dynamic-zone-component-module--listTitle--b5RXo";
export var sectionEmbeded = "dynamic-zone-component-module--sectionEmbeded--mXmm-";
export var sectionImage = "dynamic-zone-component-module--sectionImage--FQOki";
export var sectionImageCopyright = "dynamic-zone-component-module--sectionImageCopyright--yTutc";
export var sectionPlot = "dynamic-zone-component-module--sectionPlot--5Z11w";
export var subheading = "dynamic-zone-component-module--subheading--RqWdH";
export var tdCenter = "dynamic-zone-component-module--tdCenter--ENamn";
export var tdLeft = "dynamic-zone-component-module--tdLeft--ltz2J";
export var tdRight = "dynamic-zone-component-module--tdRight--Gtht-";